import { flags } from 'assets/img/icons/flags';
import { COUNTRY_DATA } from 'constants/countryData';

export const getCountryData = () => {
  return Promise.resolve(COUNTRY_DATA);
};

export const getCountryFlagUrl = (countryCode) => {
  if (!countryCode) return null;
  return flags[countryCode.toLowerCase()] || null;
};

export const getCountryByDialCode = (dialCode) => {
  return COUNTRY_DATA.find((country) => country.dialCode === dialCode);
};

export const getCountryByCode = (code) => {
  if (!code) return null;
  return COUNTRY_DATA.find(
    (country) => country.code.toLowerCase() === code.toLowerCase()
  );
};

export const getDefaultCountry = (countryCode = 'BR') => {
  return (
    getCountryByCode(countryCode) ||
    COUNTRY_DATA.find((country) => country.code === countryCode)
  );
};
